import { AxiosResponseHeaders } from 'axios';
import { isEmpty } from '@dxb-web-ui-framework/common/utils/Helper';
import { ChargingMethod, ChargingMethodResponseDTO } from '../entities';

const chargingMethodDTOToChargingMethodAdapter = (
  data: ChargingMethodResponseDTO,
  headers?: AxiosResponseHeaders,
): ChargingMethod[] => {
  if (!data.body) {
    throw new Error('Error');
  }

  const { chargingMethods } = data.body;

  if (isEmpty(chargingMethods)) {
    return [];
  }

  return chargingMethods;
};

export { chargingMethodDTOToChargingMethodAdapter };
